import './TimeSlotList.css';
export default {
    "accordionListWrapper": "TimeSlotList_accordionListWrapper__1u3mo",
    "timeSlotContainer": "TimeSlotList_timeSlotContainer__1u3mo",
    "disabled": "TimeSlotList_disabled__1u3mo",
    "signalTextContainer": "TimeSlotList_signalTextContainer__1u3mo",
    "signalWithOnlyIconWrapper": "TimeSlotList_signalWithOnlyIconWrapper__1u3mo",
    "signalTextWrapper": "TimeSlotList_signalTextWrapper__1u3mo",
    "disabledSessionText": "TimeSlotList_disabledSessionText__1u3mo",
    "sessionText": "TimeSlotList_sessionText__1u3mo"
};
